import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Works\TrashRestorationsController::store
* @see app/Http/Controllers/Works/TrashRestorationsController.php:21
* @route '/works/trash/{work}/restorations'
*/
export const store = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/works/trash/{work}/restorations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Works\TrashRestorationsController::store
* @see app/Http/Controllers/Works/TrashRestorationsController.php:21
* @route '/works/trash/{work}/restorations'
*/
store.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return store.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\TrashRestorationsController::store
* @see app/Http/Controllers/Works/TrashRestorationsController.php:21
* @route '/works/trash/{work}/restorations'
*/
store.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\TrashRestorationsController::store
* @see app/Http/Controllers/Works/TrashRestorationsController.php:21
* @route '/works/trash/{work}/restorations'
*/
const storeForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\TrashRestorationsController::store
* @see app/Http/Controllers/Works/TrashRestorationsController.php:21
* @route '/works/trash/{work}/restorations'
*/
storeForm.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

const trashRestorations = {
    store: Object.assign(store, store),
}

export default trashRestorations